import { useSelector } from 'react-redux';
import { Product } from '@/types/ecommerce.types';
import { RootState } from '@/store';
import { withQuery } from '../data/withQuery';
import { ProductTypes } from '@/types/ecommerce.types';
import { ProductVariantEdge } from '@shopify/hydrogen-react/storefront-api-types';
import { calculatePrices } from '@/utils/formatPrice';
import { getMetafieldV2, handleizeProductType } from '@/utils/utils';

type PropsType = {
  product?: Product;
  className?: string;
  variant?: ProductVariantEdge;
  showCompare?: boolean;
};

const PriceDisplayBase = ({ className, product, variant, showCompare = true }: PropsType) => {
  const { items } = useSelector((state: RootState) => state.product);
  const productType = handleizeProductType(product?.productType || '');
  const isGallery = productType === ProductTypes.GALLERY;
  const tileMetafield = getMetafieldV2('tile', product?.metafields);
  const tileMetafieldParsed = tileMetafield ? JSON.parse(tileMetafield) : [];
  const itemsLength = isGallery ? tileMetafieldParsed.length : items.length;
  const breakdown = calculatePrices({
    product,
    variant,
    isGallery,
    itemsLength,
  });

  if (!breakdown.isValid) return null;

  const { price, discountPrice, comparePrice, hasPromotionalDiscount } = breakdown;
  const hasDiscount = hasPromotionalDiscount || (showCompare && comparePrice);

  return (
    <span className={className}>
      <span
        className={`price ${hasDiscount ? 'cart-ovrl__discount-price' : ''}`}
        style={{ marginLeft: '5px' }}
      >
        {showCompare && comparePrice ? comparePrice : price}
      </span>
      <span className={`new-price ${hasDiscount ? '' : 'hide'}`}>
        {hasPromotionalDiscount ? discountPrice : price}
      </span>
    </span>
  );
};

const PriceDisplayWithQuery = withQuery(PriceDisplayBase);

const PriceDisplay = (props: PropsType) =>
  props.product ? <PriceDisplayBase {...props} /> : <PriceDisplayWithQuery {...props} />;

export default PriceDisplay;
